var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudFile = function SvgCloudFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.743 22H9.25724C7.2401 22 5.6001 20.3589 5.6001 18.3429C5.6001 16.5017 6.9681 14.9726 8.74181 14.7223C9.05038 12.9509 10.599 11.6 12.4572 11.6C12.975 11.6 13.4824 11.7051 13.9521 11.9086C14.967 10.704 16.4607 10 18.0572 10C20.807 10 23.0801 12.0766 23.3921 14.7429C25.0995 15.0503 26.4001 16.5474 26.4001 18.3429C26.4001 20.3589 24.7601 22 22.743 22Z"
  })), "/>");
};
export default SvgCloudFile;